import moment, { Moment } from 'moment';
export type ITimelineItem = {
  id: string;
  value: Moment;
  disabled?: boolean;
}

export const setTime = (hour: number, minute?: number, second?: number) => moment().set({ hour, minute: minute || 0, second: second || 0 });

const getTimeLines = (startTime: Moment, endTime: Moment, distance?: number, format = 'HH:mm') => {
  const _distance = distance || 30;
  const times: ITimelineItem[] = [];
  let time = startTime;

  while (time <= endTime) {
    times.push({
      id: time.format(format),
      value: time,
    });
    time = time.clone().add(_distance, 'minute');
  }
  return times;
};

export default getTimeLines;
